module.exports = __webpack_public_path__ + "static/media/angle-small-left.ccda8e02.svg";